import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
  ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WindowRef } from "@spartacus/core";
import { BREAKPOINT, BreakpointService, SortingComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { ICON_TYPE } from '../../../../../custom/icons/icon.model';
import {
  CustomProductListComponentService,
} from '../../../cms-components/product/custom-product-list/container/custom-product-list-component.service';

@Component({
  selector: 'app-custom-sorting',
  templateUrl: './custom-sorting.component.html',
  styleUrls: ['./custom-sorting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomSortingComponent extends SortingComponent implements OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  @Input() modalHeaderTitle: string;
  styleClass = '';
  isMobile: boolean;
  @ViewChild('orderable') orderable: ElementRef;

  @Input() set hideSortingFilters(show: boolean) {
    if (!show) {
      this.isVisible = false;
    }
  }

  iconTypes = ICON_TYPE;
  isVisible = false;

  constructor(
    protected breakpointService: BreakpointService,
    protected productListComponentService: CustomProductListComponentService,
    protected cd: ChangeDetectorRef,
    protected renderer: Renderer2,
    protected activeRoute: ActivatedRoute,
    protected winRef: WindowRef
  ) {
    super();
    this.subscriptions.add(this.isMobileService().subscribe(isMobile => {
      this.isMobile = isMobile;

      if (isMobile) {
        this.addClass(' is-mobile');
      } else {
        this.removeClass('is-mobile');
      }
      this.cd.markForCheck();
      this.removeModalClass();
    }));
    this.isVisible = this.hideSortingFilters;
  }

  sortCustomList(sortCode: string): void {
    this.productListComponentService.sortWithRoute(sortCode, this.activeRoute);
  }

  addClass(className: string): void {
    if (!this.styleClass?.includes(className)) {
      this.styleClass += className;
    }
  }

  removeClass(className: string): void {
    this.styleClass?.replace(className, '');
  }

  isMobileService(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.md);
  }

  toggleGroup(event: UIEvent): void {
    this.isVisible = !this.isVisible;
    this.hideSortingFilters = this.isVisible;
    this.removeModalClass();
  }

  removeModalClass(): void {
    if (this.isMobile) {
      if (this.isVisible) {
        this.renderer.addClass(this.winRef.document.body, 'modal-open');
      } else {
        this.renderer.removeClass(this.winRef.document.body, 'modal-open');
      }
    } else {
      this.renderer.removeClass(this.winRef.document.body, 'modal-open');
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
